import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { loginSlice } from './login/loginSlice';
import { tenantDetailSlice } from './tenantDetail/tenantDetailSlice';
import { courseDetailSlice } from './courseDetail/courseDetailSlice';
import { deleteTenantSlice } from './deleteTenant/deleteTenantSlice';
import { createUserSlice } from './createUser/createUserSlice';
import { userDetailSlice } from './userDetail/userDetailSlice';
import { impersonateDetailSlice } from './impersonateDetail/impersonateDetailSlice';
import { tenantCourseDetailSlice } from './tenantCourseDetail/tenantCourseDetailSlice';
import { tenantToCourseSlice } from './tenantToCourse/tenantToCourseSlice';

const appReducer = combineReducers({
  login: loginSlice.reducer,
  tenantDetail: tenantDetailSlice.reducer,
  tenantCourseDetail: tenantCourseDetailSlice.reducer,
  tenantToCourse: tenantToCourseSlice.reducer,
  courseDetail: courseDetailSlice.reducer,
  deleteTenant: deleteTenantSlice.reducer,
  createUser: createUserSlice.reducer,
  userDetail: userDetailSlice.reducer,
  impersonateDetail: impersonateDetailSlice.reducer
});

const store = configureStore({
  reducer: appReducer,
});

export default store;
